<script>
import ModalWrapper from "@/components/modals/ModalWrapper";
import PrimaryButton from "@/components/PrimaryButton";

export default {
  name: "ModifySeedModal",
  components: {
    ModalWrapper,
    PrimaryButton,
  },
  data() {
    return {
      mode: 0,
      inputSeed: "",
      seedText: "",
      convertedInput: false,
      seedValue: 0,
    };
  },
  computed: {
    choiceEnum: () => SPEEDRUN_SEED_STATE,
    officialSeed: () => Speedrun.officialFixedSeed,
  },
  created() {
    this.seedValue = player.speedrun.initialSeed;
    this.inputSeed = `${player.speedrun.initialSeed}`;
    this.convertedInput = false;
  },
  methods: {
    update() {
      this.mode = player.speedrun.seedSelection;
      this.seedText = Speedrun.seedModeText();
    },
    handleSeedInput() {
      if (this.inputSeed.match(/^-?\d+$/gu)) {
        const num = Number(this.inputSeed);
        this.seedValue = Math.abs(num) > 9e15
          ? this.hashStringToSeed(this.inputSeed)
          : Number(this.inputSeed);
      } else {
        this.seedValue = this.hashStringToSeed(this.inputSeed);
      }
      this.convertedInput = this.seedValue !== Number(this.inputSeed);

      if (this.seedValue === 0) this.setMode(this.choiceEnum.FIXED);
      else this.setMode(this.choiceEnum.PLAYER, this.seedValue);
    },
    setMode(mode, seed) {
      if (mode === this.choiceEnum.PLAYER && this.seedValue === 0) return;
      Speedrun.modifySeed(mode, parseInt(seed, 10));
    },
    buttonClass(mode) {
      return {
        "o-primary-btn--subtab-option": true,
        "o-selected": mode === this.mode,
      };
    },
    // String-to-number hashing function, using a fixed numerical seed inspired by Number.MAX_VALUE
    // See https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
    hashStringToSeed(str) {
      const seed = 17977308;
      let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
      for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
      }
      h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
      h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
      return 4294967296 * (2097151 & h2) + (h1 >>> 0);
    }
  },
};
</script>

<template>
  <ModalWrapper>
    <template #header>
      Modifying Glyph RNG Seed
    </template>
    <div>
      Все параметры Глифа после первой Реальности до конца игры случайным образом определены с самого начала,
      основываясь на значении первичного номера сида. Роль этого сида заключается в том, что он выбирает один,
      <i>определённый</i> набор параметров Глифа для вашего прохождения. Если вы или кто-нибудь ещё выбирает один и тот
      же сид в другой игре, вы получите те же самые опции для Глифов.
      <br>
      <br>
      Вы можете переключаться между этими тремя опциями в любой момент до того как вы получили свой первый Глиф.
      <br>
      Текущая настройка: <b>{{ seedText }}</b>
      <br>
      <br>
      <PrimaryButton
        :class="buttonClass(choiceEnum.FIXED)"
        @click="setMode(choiceEnum.FIXED)"
      >
        Официальный Сид Пресета
      </PrimaryButton>
      <br>
      Это стандартная настройка, которая выбирает сид <b>{{ officialSeed }}</b>. Любой, кто
      выбирает не изменять сид получит эти параметры Глифов.
      <br>
      <br>
      <PrimaryButton
        :class="buttonClass(choiceEnum.RANDOM)"
        @click="setMode(choiceEnum.RANDOM)"
      >
        Случайный Сид
      </PrimaryButton>
      <br>
      Это выбирает случайное щначение сида, производя параметры Глифов, которые с огромной вероятностью будут
      отличаться от чьих-либо ещё, если тоьлко они не выбрали то же самое значение сида намеренно.
      <br>
      <br>
      <PrimaryButton
        v-tooltip="seedValue === 0 ? 'Input seed cannot be zero!' : ''"
        :class="buttonClass(choiceEnum.PLAYER)"
        @click="setMode(choiceEnum.PLAYER, seedValue)"
      >
        Сид выбираемый игроком:
      </PrimaryButton>
      <input
        ref="inputSeed"
        v-model="inputSeed"
        type="text"
        class="c-modal-input"
        @input="handleSeedInput()"
      >
      <br>
      Эта настройка устанавливает ваш равным значению, которое вы укажите в текстовом поле.
      <br>
      <span v-if="seedValue !== 0">
        Ваш текущий ввод будет {{ convertedInput ? "конвертирован в" : "использован как" }} число <b>{{ seedValue }}</b>.
      </span>
      <span v-else>
        Ваш текущий ввод {{ convertedInput ? "конвертируется в" : "равен" }} <b>0</b>;
        сид будет установлен на Официальный Пресет.
      </span>
      <br>
      По техническим причинам, это значение должно быть ненулевым.
    </div>
  </ModalWrapper>
</template>

<style scoped>
.o-selected {
  color: var(--color-text-inverted);
  background-color: var(--color-good);
}
</style>
